import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const accounts = (rawClient) => ({
    current: {
        update: allpeepPayloadEndpoint(rawClient, '/accounts/current', 'patch'),
        read: allpeepNoPayloadEndpoint(rawClient, '/accounts/current'),
        export: allpeepNoPayloadEndpoint(rawClient, '/accounts/current/export'),
        createPushSubscription: allpeepPayloadEndpoint(rawClient, '/accounts/current/push-subscriptions'),
        listPushSubscriptions: allpeepNoPayloadEndpoint(rawClient, '/accounts/current/push-subscriptions'),
        testPushSubscription: allpeepPayloadEndpoint(rawClient, '/accounts/current/push-subscriptions/test'),
        validationEmail: allpeepNoPayloadEndpoint(rawClient, '/accounts/current/validation-email', 'post'),
        deletePushSubcription: allpeepNoPayloadEndpoint(rawClient, '/accounts/current/push-subscriptions/:pushSubscriptionId', 'delete'),
    },
});
